<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Edit Barber</h1>
      </div>
    </div>
    <b-card class="mt-3">
      <b-row>
        <b-col md="6" offset-md="3">
          <div v-if="loading" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
          <b-alert v-else-if="error" class="text-center" variant="danger" show>
            <p>Something went wrong...</p>
            <strong>error</strong>
            <router-link class="btn btn-primary" :to="{ name: 'resources' }">
              Back to Barbers
            </router-link>
          </b-alert>
          <resource-form
            v-else
            :resource="resource"
            :saving="saving"
            @submit="submit"
          ></resource-form>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ResourceForm from './ResourceForm';

export default {
  components: {
    ResourceForm
  },
  methods: {
    ...mapActions({
      fetchResource: 'resources/fetchResource',
      updateResource: 'resources/updateResource'
    }),
    async submit(resource) {
      try {
        this.saving = true;
        await this.updateResource(resource);
        this.$notify({
          type: 'success',
          text: 'Barber updated'
        });
        this.$router.push({ name: 'resources' });
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      } finally {
        this.saving = false;
      }
    }
  },
  computed: {
    resource() {
      return this.$store.getters['resources/resourceById'](
        this.$route.params.id
      );
    }
  },
  data() {
    return {
      loading: true,
      saving: false,
      error: null
    };
  },
  async created() {
    const { id } = this.$route.params;

    if (!id) {
      this.$router.push({ name: 'resources' });
    }

    try {
      if (!this.resource) {
        await this.fetchResource(id);
      }
    } catch (e) {
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  }
};
</script>
